import React, { Fragment, useState, useRef, useMemo } from 'react'
import {
  Box,
  Fade,
  Typography,
  IconButton,
  TextField,
  useMediaQuery
} from '@material-ui/core'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { donateAmount } from 'actions/event'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { openLoginDialog } from 'actions/login-dialog'
import { openSnackBar } from 'actions/snack-bar'
import lottieJson from 'assets/small-lottie.json'
import bigLottie from 'assets/big-lottie.json'
import { Formik, Form } from 'formik'
import LoaderButton from 'components/LoaderButton'
import * as Yup from 'yup'
import HelpText from '../HelpText'
import { formatMoney } from 'accounting'
import CheckIcon from '@material-ui/icons/Check'
import Button from '../Button'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import Gradient from 'components/Gradient'

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const vibrateArr = [
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20
]

class DonateButton extends React.Component {
  state = {
    animationTimeout: null
  }
  onStart = e => {
    this.setState({
      animationTimeout: setTimeout(() => {
        this.props.donate(this.props.option.val)
        setTimeout(() => {
          this.setState({ showAnimation: false })
        }, 600)
      }, 600),
      showAnimation: true
    })
  }

  onEnd = e => {
    clearTimeout(this.state.animationTimeout)
    this.setState({ animationTimeout: null, showAnimation: false })
  }

  render() {
    const { option, classes, onClick } = this.props
    const { showAnimation } = this.state
    return (
      <Button className={classes.donateOption} onAction={onClick}>
        <div
          className={classes.bidGlow}
          style={{
            width: showAnimation ? '100%' : '0%',
            transition: showAnimation
              ? 'width 500ms ease-in-out'
              : 'width 200ms ease-in-out',
            borderRadius: '8px'
          }}
        />
        ${numberWithCommas(option.val)}
      </Button>
    )
  }
}

const Schema = Yup.object().shape({
  customAmount: Yup.number()
    .required('Custom amount required')
    .min(1, 'Custom amount should be greater than 0')
})

let showThanksTimeout = null

const DonateButtons = ({ classes }) => {
  const dispatch = useDispatch()
  const orientation = useSelector(state => state.window.orientation)
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const { fullScreen } = useFullScreen()
  const isLandscape = useMediaQuery(
    '(max-width: 1023px) and (orientation: landscape)'
  )
  const isMobile = useMediaQuery('(max-width: 767px)')
  const [showThanks, setShowThanks] = useState(false)
  const [showCustom, setShowCustom] = useState(false)
  const [donateSpeedDialOpen, setDonateSpeedDialOpen] = useState(false)
  const [showDonateSuccess, setShowDonateSuccess] = useState(false)
  const [customAmount, setCustomAmount] = useState('')
  const [selectedDonateAmount, setSelectedDonateAmount] = useState(0)
  const [showConfirm, setShowConfirm] = useState(false)
  const event = useSelector(state => state.event.event)
  const liveSettings = event.live_settings
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  // refs
  const customDonateRef = useRef(null)

  let donateOptions = []
  if (event && event.giving_levels) {
    try {
      donateOptions = JSON.parse(event.giving_levels)
    } catch (err) {
      console.log(err)
    }
  }

  const checkLogin = (cb, ...args) => {
    if (isEmpty(authenticatedUser)) {
      dispatch(openLoginDialog())
        .then(response => {
          cb(...args, response)
        })
        .fail(() => {
          args[1].setSubmitting(false)
        })
    } else {
      cb(...args)
    }
  }

  const submitDonate = (values, actions, loginResponse) => {
    return dispatch(
      donateAmount(
        event.auction_code,
        loginResponse ? loginResponse.user_id : authenticatedUser.user_id,
        values.customAmount,
        values.anonFlag
      )
    )
      .then(() => {
        setShowConfirm(false)
        setShowDonateSuccess(true)
        setShowThanks(true)
        showThanksTimeout = setTimeout(() => {
          setShowThanks(false)
        }, 8000)
        if (navigator.vibrate) {
          navigator.vibrate(vibrateArr)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 3000)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 6000)
        }
        setTimeout(() => {
          actions.resetForm()
          setShowCustom(false)
        }, 300)
      })
      .finally(() => {
        if (actions) {
          actions.setSubmitting(false)
        }
      })
  }

  const submitDonateAnonymous = (values, actions, loginResponse) => {
    return dispatch(
      donateAmount(
        event.auction_code,
        loginResponse ? loginResponse.user_id : authenticatedUser.user_id,
        values.customAmount,
        1
      )
    )
      .then(() => {
        setShowConfirm(false)
        setShowDonateSuccess(true)
        setShowThanks(true)
        showThanksTimeout = setTimeout(() => {
          setShowThanks(false)
        }, 8000)
        if (navigator.vibrate) {
          navigator.vibrate(vibrateArr)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 3000)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 6000)
        }
        setTimeout(() => {
          actions.resetForm()
          setShowCustom(false)
        }, 300)
      })
      .finally(() => {
        if (actions) {
          actions.setSubmitting(false)
        }
      })
  }

  const Schema = Yup.object().shape({
    customAmount: Yup.number()
      .required('Custom amount required')
      .min(1, 'Custom amount should be greater than 0')
  })

  const handleButtonClick = amount => {
    setDonateSpeedDialOpen(false)
    setSelectedDonateAmount(amount)
    setTimeout(() => {
      setShowConfirm(true)
    }, 40)
  }

  const handleCloseConfirm = resetForm => {
    setShowConfirm(false)
    setTimeout(() => {
      setShowCustom(false)
      resetForm()
    }, 300)
  }

  const handleCustomClicked = () => {
    setShowCustom(true)
    setTimeout(() => {
      if (customDonateRef.current) {
        customDonateRef.current.focus()
      }
    }, 300)
    setTimeout(() => {
      setShowConfirm(true)
    }, 40)
  }

  const handleDonateSpeedDialOpen = () => {
    setDonateSpeedDialOpen(true)
  }

  const handleDonateSpeedDialClose = () => {
    setDonateSpeedDialOpen(false)
  }

  const handleCloseThanks = () => {
    setShowThanks(false)
    clearTimeout(showThanksTimeout)
    showThanksTimeout = null
  }

  const showTapToDonate = useMemo(() => {
    return (
      donateOptions.filter(
        x => x && x.hasOwnProperty('display') && x.display.toString() === 'true'
      ).length > 0 || Number(String(event.custom_giving_level)) > 0
    )
  }, [donateOptions, event.custom_giving_level])

  const visibleDonateButtons = donateOptions.filter(
    x => x && x.hasOwnProperty('display') && x.display.toString() === 'true'
  )

  const shouldShowSpeedDial = useMemo(() => {
    if (visibleDonateButtons.length === 0) {
      // no amount buttons are shown
      if (Number(String(event.custom_giving_level))) {
        return false
      } else {
        return true
      }
    } else if (visibleDonateButtons.length === 1) {
      if (Number(String(event.custom_giving_level))) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }, [visibleDonateButtons.length, event.custom_giving_level])

  return (
    <Box
      className={classnames(classes.donateButtons, classes[orientation], {
        [classes.isFullscreen]: fullScreen || windowFullscreen
      })}
    >
      <Fade in={showThanks}>
        <Box className={classes.blueBox}>
          <IconButton
            size="small"
            className={classes.closeConfirmButton}
            onClick={handleCloseThanks}
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.confirmText}>
            <CheckIcon /> Successfully added to your cart
          </Typography>
        </Box>
      </Fade>
      <Fade in={showConfirm} timeout={25}>
        <Box className={classes.blueBox}>
          <Formik
            initialValues={{ customAmount: '' }}
            validationSchema={Schema}
            onSubmit={(...args) => checkLogin(submitDonate, ...args)}
          >
            {props => (
              <Form className={classes.form}>
                <IconButton
                  size="small"
                  className={classes.closeConfirmButton}
                  onClick={() => handleCloseConfirm(props.resetForm)}
                >
                  <CloseIcon />
                </IconButton>
                {showCustom && (
                  <Fragment>
                    <Typography className={classes.confirmText}>
                      Enter custom donation amount
                    </Typography>
                    <TextField
                      className={classes.textField}
                      // label="Donation Amount"
                      name="customAmount"
                      value={props.values.customAmount}
                      onChange={props.handleChange}
                      type="number"
                      inputRef={customDonateRef}
                      error={Boolean(props.errors.customAmount)}
                      helperText={props.errors.customAmount || ' '}
                      InputProps={{
                        classes: {
                          root: classes.inputRoot,
                          underline: classes.inputUnderline
                        }
                      }}
                      FormHelperTextProps={{
                        classes: {
                          root: classes.formHelperError
                        }
                      }}
                    />
                    <TextField
                      className={classes.hiddenTextField}
                      name="anonFlag"
                      value={0}
                      type="number"
                    />
                    <LoaderButton
                      type="button"
                      variant="contained"
                      onClick={() => {
                        props.setFieldValue('anonFlag', 0)
                        setTimeout(() => {
                          props.handleSubmit()
                        }, 40)
                      }}
                      classes={{ button: classes.confirmButton }}
                      working={
                        props.isSubmitting && props.values.anonFlag === 0
                      }
                    >
                      Confirm
                    </LoaderButton>
                    <LoaderButton
                      type="button"
                      onClick={() => {
                        props.setFieldValue('anonFlag', 1)
                        setTimeout(() => {
                          props.handleSubmit()
                        }, 40)
                      }}
                      variant="contained"
                      classes={{ button: classes.confirmButton }}
                      working={
                        props.isSubmitting && props.values.anonFlag === 1
                      }
                    >
                      Confirm Anonymously
                    </LoaderButton>
                  </Fragment>
                )}
                {!showCustom && (
                  <Fragment>
                    <Typography className={classes.confirmText}>
                      You are donating{' '}
                      {formatMoney(selectedDonateAmount, '$', 0)}
                    </Typography>
                    <TextField
                      className={classes.hiddenTextField}
                      name="anonFlag"
                      value={0}
                      type="number"
                    />
                    <LoaderButton
                      type="button"
                      onClick={() => {
                        props.setFieldValue(
                          'customAmount',
                          selectedDonateAmount
                        )
                        props.setFieldValue('anonFlag', 0)
                        setTimeout(() => {
                          props.handleSubmit()
                        }, 40)
                      }}
                      variant="contained"
                      classes={{ button: classes.confirmButton }}
                      working={
                        props.isSubmitting && props.values.anonFlag === 0
                      }
                    >
                      Confirm
                    </LoaderButton>
                    {/*additional button to donate anymously*/}
                    <LoaderButton
                      type="button"
                      onClick={() => {
                        props.setFieldValue(
                          'customAmount',
                          selectedDonateAmount
                        )
                        props.setFieldValue('anonFlag', 1)
                        setTimeout(() => {
                          props.handleSubmit()
                        }, 40)
                      }}
                      variant="contained"
                      classes={{ button: classes.confirmButton }}
                      working={
                        props.isSubmitting && props.values.anonFlag === 1
                      }
                    >
                      Confirm Anonymously
                    </LoaderButton>
                  </Fragment>
                )}
              </Form>
            )}
          </Formik>
        </Box>
      </Fade>
      <Fade in={showConfirm === false && showThanks === false} timeout={25}>
        <div>
          {((!isLandscape && !liveSettings.compact_buttons) || isMobile) && (
            <Box className={classes.donateButtonsBox}>
              {showTapToDonate && <HelpText>Tap to donate</HelpText>}
              <Box
                display="flex"
                justifyContent="center"
                className={classes.buttons}
              >
                <Box className={classes.amountButtons}>
                  {visibleDonateButtons.slice(0,3)
                  .map((option, i) => {
                    return (
                      <DonateButton
                        key={i}
                        option={option}
                        classes={classes}
                        onClick={() => handleButtonClick(option.val)}
                        // donate={() => submitDonate({ customAmount: option.val })}
                      />
                    )
                  })}
                </Box>
                {/* amountButtons */}
                {Number(String(event.custom_giving_level)) ? (
                  <Button
                    className={classes.button}
                    onAction={handleCustomClicked}
                  >
                    Enter Amount
                  </Button>
                ) : null}
              </Box>
              {/* buttons */}
            </Box>
          )}
          {(isLandscape || liveSettings.compact_buttons) && !isMobile && (
            <Box className={classes.donateButtonsBox}>
              {shouldShowSpeedDial && (
                <SpeedDial
                  ariaLabel="Donate"
                  className={classes.speedDial}
                  FabProps={{
                    color: 'secondary'
                  }}
                  icon={<Typography>Donate</Typography>}
                  onClose={handleDonateSpeedDialClose}
                  onOpen={handleDonateSpeedDialOpen}
                  open={donateSpeedDialOpen}
                  direction="up"
                >
                  {visibleDonateButtons.slice(0,3)
                  .map((option, i) => {
                    if (option.val > 0) {
                      return (
                        <SpeedDialAction
                          TooltipClasses={{ popper: classes.tooltip }}
                          key={i}
                          icon={
                            <Typography>
                              ${numberWithCommas(option.val)}
                            </Typography>
                          }
                          onClick={() => handleButtonClick(option.val)}
                        />
                      )
                    }
                  })}
                  {/* amountButtons */}
                  {Number(String(event.custom_giving_level)) ? (
                    <SpeedDialAction
                      TooltipClasses={{ popper: classes.tooltip }}
                      icon={<Typography>Custom Amount</Typography>}
                      onClick={handleCustomClicked}
                    />
                  ) : null}
                </SpeedDial>
              )}
              {!shouldShowSpeedDial && (
                <Box className={classes.compactDonateButtons}>
                  {visibleDonateButtons.slice(0,3)
                  .map((option, i) => {
                    if (option.val > 0) {
                      return (
                        <Button
                          key={i}
                          onClick={() => handleButtonClick(option.val)}
                          className={classes.speedDialButton}
                        >
                          <Typography>
                            ${numberWithCommas(option.val)}
                          </Typography>
                        </Button>
                      )
                    }
                  })}
                  {/* amountButtons */}
                  {Number(String(event.custom_giving_level)) ? (
                    <Button
                      onClick={handleCustomClicked}
                      className={classes.speedDialButton}
                    >
                      <Typography>Donate</Typography>
                    </Button>
                  ) : null}
                </Box>
              )}
            </Box>
          )}
          {/* fade inner Box */}
        </div>
      </Fade>
      <div className={classes.donateWrapper}>
        {showThanks && (
          <Fragment>
            <lottie-player
              src={JSON.stringify(lottieJson)}
              background="transparent"
              speed="1"
              style={{
                width: 300,
                height: 300,
                position: 'absolute',
                top: '-200px',
                left: '50%',
                transform: 'translateX(-50%)'
              }}
              autoplay
              loop
            />
            {/* <lottie-player
                src={JSON.stringify(bigLottie)}
                background="transparent"
                speed="1"
                style={{
                  width: '100vw',
                  height: '100vh',
                  position: 'absolute',
                  top: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'none'
                }}
                autoplay
                loop
              /> */}
          </Fragment>
        )}
      </div>
      {!liveSettings.compact_buttons && <Gradient />}
    </Box>
  )
}
export default withStyles(styles, { withTheme: true })(DonateButtons)



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/DonateButtons/index.jsx